import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Preview's visual-edit transform adds diagnostic wrappers that aren't part of
// the static HTML. Production hydrates the exact prerendered component tree.
if (process.env.NODE_ENV === 'production' && container.hasChildNodes() && container.dataset.staticPath === window.location.pathname) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
